import { Component, EventEmitter, Input, Output } from '@angular/core';
import { enumCardStyle } from '@shared/cards/enums';

@Component({
  selector: 'card-default',
  templateUrl: './card-default.component.html',
  styleUrls: ['./card-default.component.scss'],
})
export class CardDefaultComponent {
  @Input() public style: enumCardStyle = enumCardStyle.DEFAULT;
  @Input() public title: string = '';
  @Input() public description: string = '';
  @Input() public sticky: boolean = false;
  @Input() public showFooter: boolean = true;
  @Output() public headerClick: EventEmitter<Event> = new EventEmitter<Event>();
  constructor() {}

  public onHeaderClick(event: Event) {
    this.headerClick.emit(event);
  }

  public get class(): string {
    return 'mode-' + enumCardStyle[this.style].toLowerCase();
  }

  public get ngClass() {
    return { sticky: this.sticky, [this.class]: !!this.class };
  }
}
